export class SheetActivity{
  id: number = 0
  student_id: number = 0
  page: number = 0
  angle: number = 0
  baseWidth: number = 0
  baseHeight: number = 0
  base64Image: string | null = null

  constructor(sa: any){
    this.id = sa.id;
    this.student_id = sa.student_id;
    this.page = sa.page;
  }
 }

 export class Examinee{
  id: number = 0
  student_no: number = 0
  absent_flg: boolean = false
  student_no_character: string = ""
  student_name: string = ""
  room_name: string = ""
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  isAbsent: boolean = false
  email: string = ""

  constructor(examinee: any, sheet_activities: any[]){
    this.id = examinee.id;
    this.student_no = examinee.student_no;
    this.absent_flg = examinee.absent_flg;
    this.student_no_character = examinee.student_no_character;
    this.student_name = examinee.student_name;
    this.room_name = examinee.room_name;
    this.email = examinee.email;
    
    const sheetActivities = new Array<SheetActivity>();
    sheet_activities.filter((x: any) => x.student_id == this.student_no).forEach((x: any) => {
      sheetActivities.push(new SheetActivity(x));
    });
    
    this.sheetActivities = sheetActivities.sort((a: SheetActivity, b: SheetActivity) => a.page < b.page ? -1 : 1);
  }
}